import React from 'react';
import { AlertTriangleIcon, CheckIcon, CrownIcon, LockIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { purchaseUrls } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const baseFeatures = ['5 Tomos PDF completos', '5 Bonos de Gimnasio (200 páginas)', 'Acceso inmediato en 5 minutos', 'Garantía total de 7 días'];
const premiumFeatures = ['Todo el Combo Completo Futsal', 'Ejercicios avanzados de reacción extrema', 'Método de Complejos y RFD', 'Circuitos integrados Cancha + Gym', 'Programa avanzado de 8 semanas'];
function PlanCard({
  premium = false,
  compact = false
}: {
  premium?: boolean;
  compact?: boolean;
}) {
  const features = premium ? premiumFeatures : baseFeatures;
  const title = premium ? 'Combo Completo + Alto Rendimiento' : 'Combo Completo Futsal';
  const subtitle = premium ? '5 Tomos + 5 Bonos + 50 páginas Élite' : '5 Tomos + 5 Bonos';
  return <article className={`relative flex flex-col rounded-3xl p-6 ${premium ? 'bg-primary text-white shadow-[0_25px_60px_rgba(7,59,92,.35)] ring-4 ring-gold/30 md:scale-[1.025]' : 'border border-sky-100 bg-white shadow-sm'} ${compact ? 'text-left' : 'md:p-8'}`} data-id="element-262">
      {premium && <div className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full bg-gold px-4 py-1.5 text-xs font-extrabold text-slate-900 shadow-lg" data-id="element-263">
          <StarIcon className="h-4 w-4 fill-current" data-id="element-264" /> MÁS ELEGIDO
        </div>}

      <div className={premium ? 'mt-2' : ''} data-id="element-265">
        <div className="flex items-start gap-2" data-id="element-266">
          <span className="text-3xl" data-id="element-267">{premium ? '🏆' : '📘'}</span>
          <h3 className={`text-xl font-extrabold leading-tight ${premium ? 'text-white' : 'text-slate-900'}`} data-id="element-268">
            {title}
          </h3>
        </div>
        <p className={`mt-2 text-sm font-medium ${premium ? 'text-sky-100' : 'text-slate-500'}`} data-id="element-269">
          {subtitle}
        </p>
      </div>

      {!compact && <p className={`my-6 rounded-xl border p-4 text-sm leading-relaxed ${premium ? 'border-white/20 bg-white/10 text-sky-50' : 'border-sky-100 bg-sky-50/70 text-slate-600'}`} data-id="element-270">
          <b className={premium ? 'text-white' : 'text-slate-900'} data-id="element-271">
            Ideal para:
          </b>{' '}
          {premium ? 'Entrenadores que quieren llevar su grupo a un nivel superior con estímulos avanzados de cancha y gimnasio.' : 'Entrenadores que quieren dejar de improvisar y tener cada sesión de Futsal lista, clara y conectada.'}
        </p>}

      <ul className="my-6 flex-1 space-y-2" data-id="element-272">
        {features.map(feature => <li key={feature} className={`flex items-start gap-2 text-sm font-medium ${premium ? 'text-white' : 'text-slate-700'}`} data-id="element-273">
            <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${premium ? 'text-gold' : 'text-teal'}`} data-id="element-274" />
            {feature}
          </li>)}
      </ul>

      <div className="mb-6" data-id="element-275">
        {premium && <span className="mb-3 inline-block rounded-full bg-gold px-3 py-1 text-xs font-extrabold text-slate-900" data-id="element-276">
            AHORRÁS $47.000
          </span>}
        <p className={`text-sm font-bold line-through ${premium ? 'text-sky-200' : 'text-slate-400'}`} data-id="element-277">
          Antes: {premium ? '$75.000' : '$60.000'}
        </p>
        <p className={`mt-1 text-xs font-bold uppercase ${premium ? 'text-sky-100' : 'text-slate-500'}`} data-id="element-278">
          Hoy
        </p>
        <p className={`text-4xl font-extrabold ${premium ? 'text-white md:text-5xl' : 'text-slate-900'}`} data-id="element-279">
          {premium ? '$27.990' : '$19.990'}
        </p>
      </div>

      <Button href={premium ? purchaseUrls.highPerformance : purchaseUrls.futsal} fullWidth className={premium ? 'bg-gold text-xs text-slate-900 shadow-gold/30 hover:bg-[#ddb248]' : 'text-xs'} data-id="element-280">
        {premium ? 'QUIERO COMBO + ALTO RENDIMIENTO' : 'QUIERO EL COMBO COMPLETO FUTSAL'}
      </Button>
    </article>;
}
export function Pricing() {
  return <section id="pricing" className="mx-auto max-w-6xl scroll-mt-16 px-4 py-16 md:py-24" data-id="element-281">
      <div className="text-center" data-id="element-282">
        <p className="text-[11px] font-bold uppercase tracking-[.16em] text-teal md:text-sm" data-id="element-283">
          ⏰ Precio de lanzamiento activo hoy
        </p>
        <h2 className="mx-auto mt-3 max-w-2xl text-2xl font-extrabold leading-tight text-slate-900 md:text-4xl" data-id="element-284">
          Asegurá el precio promocional{' '}
          <span className="text-teal" data-id="element-285">antes de que suba.</span>
        </h2>
        <div className="mt-6" data-id="element-286">
          <Countdown data-id="element-287" />
        </div>
        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-288">
          {['Después sube $9.000 ARS', 'Esta promo no vuelve', '72% de los cupos ya tomados'].map(item => <span key={item} className="inline-flex items-center gap-1 rounded-full border border-red-200 bg-red-50 px-3 py-1.5 text-[11px] font-bold text-red-600" data-id="element-289">
              <AlertTriangleIcon className="h-3.5 w-3.5" data-id="element-290" /> {item}
            </span>)}
        </div>
      </div>

      <h2 className="mt-14 text-center text-3xl font-extrabold text-slate-900 md:text-5xl" data-id="element-291">
        Elegí tu <span className="text-teal" data-id="element-292">opción</span>
      </h2>
      <div className="mx-auto mt-10 grid max-w-5xl gap-8 md:grid-cols-2" data-id="element-293">
        <PlanCard data-id="element-294" />
        <PlanCard premium data-id="element-295" />
      </div>
      <p className="mt-9 text-center text-xs font-medium text-slate-500" data-id="element-296">
        Pago 100% seguro · Acceso en 5 minutos · Mercado Pago hasta 12 cuotas
      </p>
    </section>;
}
export function Upsell() {
  const rows = [['Reacción y arranque', 'Tareas genéricas', 'Estímulos de reacción extrema'], ['Potencia en cancha', 'Saltos aislados', 'Método de Complejos y RFD'], ['Trabajo físico', 'Gym separado del juego', 'Circuitos integrados Cancha + Gym'], ['Cambios de dirección', 'Sin progresión', 'Drills avanzados específicos'], ['Carga semanal', 'A ojo y sin control', 'Programa avanzado de 8 semanas'], ['Rendimiento competitivo', 'Mismo estímulo de siempre', 'Una ventaja real para tu equipo']];
  return <section className="border-y border-sky-100 bg-sky-50/70 px-4 py-16 md:py-24" data-id="element-297">
      <div className="mx-auto max-w-5xl" data-id="element-298">
        <p className="mb-3 text-center text-[11px] font-bold uppercase tracking-[.16em] text-gold md:text-sm" data-id="element-299">
          <CrownIcon className="mr-1 inline h-4 w-4" data-id="element-300" /> Upgrade premium
        </p>
        <h2 className="mx-auto max-w-3xl text-center text-2xl font-extrabold leading-tight text-slate-900 md:text-4xl" data-id="element-301">
          ¿Qué agrega el <span className="text-teal" data-id="element-302">Alto Rendimiento?</span>
        </h2>

        <div className="mt-10 rounded-3xl border border-teal/25 bg-white p-3 shadow-lg shadow-teal/10 sm:p-6 md:p-10" data-id="element-303">
          <div className="grid grid-cols-3 gap-2 border-b border-sky-100 pb-4 text-[10px] font-bold uppercase tracking-wide text-slate-500 sm:text-sm" data-id="element-304">
            <span data-id="element-305">Situación</span>
            <span className="text-red-500" data-id="element-306">Combo Base</span>
            <span className="text-teal" data-id="element-307">Con Alto Rendimiento</span>
          </div>
          {rows.map(([situation, without, withValue]) => <div key={situation} className="grid grid-cols-3 gap-2 border-b border-sky-50 py-3 last:border-0" data-id="element-308">
              <b className="text-[11px] leading-tight text-slate-900 sm:text-sm" data-id="element-309">
                {situation}
              </b>
              <span className="text-[11px] leading-tight text-slate-500 sm:text-sm" data-id="element-310">
                {without}
              </span>
              <b className="rounded-lg bg-teal/10 px-1.5 py-1 text-[11px] leading-tight text-teal sm:px-3 sm:text-sm" data-id="element-311">
                {withValue}
              </b>
            </div>)}
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center font-medium leading-relaxed text-slate-700" data-id="element-312">
          Si querés que tu equipo entrene con un estímulo superior, el{' '}
          <b className="text-teal" data-id="element-313">Alto Rendimiento es la opción para vos.</b>
        </p>
      </div>
    </section>;
}
export function FinalCTA() {
  return <section className="relative overflow-hidden px-4 py-16 md:py-24" data-id="element-314">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-teal/10 blur-[130px]" data-id="element-315" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-316">
        <h2 className="text-3xl font-extrabold leading-tight text-slate-900 md:text-5xl" data-id="element-317">
          Tus entrenamientos de Futsal,{' '}
          <span className="text-teal" data-id="element-318">listos desde hoy.</span>
        </h2>
        <p className="mt-4 text-lg font-medium text-slate-600" data-id="element-319">
          Sin buscar. Sin armar. Sin improvisar.
        </p>
        <p className="mt-8 text-sm font-bold uppercase tracking-wide text-slate-500" data-id="element-320">
          ⏰ El precio cierra en:
        </p>
        <div className="mt-4" data-id="element-321">
          <Countdown data-id="element-322" />
        </div>
        <div className="mx-auto mt-12 grid max-w-5xl gap-7 md:grid-cols-2" data-id="element-323">
          <PlanCard compact data-id="element-324" />
          <PlanCard compact premium data-id="element-325" />
        </div>
        <div className="mt-9 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-medium text-slate-500" data-id="element-326">
          <span className="flex gap-1" data-id="element-327">
            <LockIcon className="h-4 w-4 text-teal" data-id="element-328" /> Pago 100% seguro
          </span>
          <span className="flex gap-1" data-id="element-329">
            <ZapIcon className="h-4 w-4 text-teal" data-id="element-330" /> Acceso en 5 minutos
          </span>
          <span className="flex gap-1" data-id="element-331">
            <ShieldCheckIcon className="h-4 w-4 text-teal" data-id="element-332" /> Garantía de 7 días
          </span>
        </div>
      </div>
    </section>;
}